import { render, staticRenderFns } from "./add-group-member.vue?vue&type=template&id=060d6e7e&scoped=true&"
import script from "./add-group-member.vue?vue&type=script&lang=js&"
export * from "./add-group-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d6e7e",
  null
  
)

export default component.exports